Vue.component('story-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            //
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // Listen for application initialization , for first page load.
        EventBus.$once('page-init-complete', this.enterStory);

        // Listen for transition complete, for transition page load.
        EventBus.$once('page-story-init', this.enterStory);

        // Make sure we can scroll
        this.$root.removeScrollListener();

        EventBus.$off('user-scroll-down');
        EventBus.$off('user-scroll-up');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        /**
         * Enter story page.
         *
         * @returns {Void}
         */
        enterStory(delay = 0) {
            this.enterStoryTl = new TimelineMax({ paused: true, delay, immediateRender: true });

            this.enterStoryTl.fromTo('.title-holder .line', 0.6, { scaleY: '0', ease: Power2.easeOut }, { scaleY: '1', ease: Power2.easeOut });
            this.enterStoryTl.fromTo('.title-holder .subline .movement-container', 0.8, { y: '120%' }, { y: '0%', ease: Power3.ease }, 0.3);
            this.enterStoryTl.staggerFromTo('.title-holder h1 .movement-container', 0.8, { y: '110%' }, { y: '0%', ease: Power3.easeOut }, 0.1, 0.3);
            this.enterStoryTl.fromTo('.reading-time .movement-container', 0.8, { y: '120%', ease: Power3.ease }, { y: '0%', ease: Power3.ease }, 0.3);
            this.enterStoryTl.fromTo('.modules-container', 0.8, { y: '50px', autoAlpha: '0', ease: Power3.ease }, { y: '0', autoAlpha: '1', ease: Power3.ease }, 0.3);
            this.enterStoryTl.staggerFromTo('.social-icon', 0.3, { autoAlpha: '0', scale: '0' }, {
                delay: '-0.1',
                autoAlpha: '1',
                scale: '1.1',
                onCompleteParams: ['{self}'],
                onComplete(tween) {
                    TweenMax.to(tween.target, 0.2, { scale: '1' });
                },
            }, 0.1);
            this.enterStoryTl.to('.story-image .overlay-animation', window.transitionVars.imageEnterDuration, { scaleX: '0', ease: Expo.easeOut }, window.transitionVars.imageEnter);

            this.enterStoryTl.set(['.modules-container'], { clearProps: 'all' });

            this.enterStoryTl.play();
        },
    },

    beforeDestroy() {
        EventBus.$off('page-init-complete', this.enterStory);
        EventBus.$off('page-transition-complete', this.enterStory);
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/story-component.js